export default [
  {
    path: 'credits',
    name: 'list-debt-credits',
    component: () =>
      import(/* webpackChunkName: "list-debt-credits-bill" */ './List.vue'),
    meta: {
      title: 'Công nợ quẹt thẻ hóa đơn theo ngày - Clickbuy',
    },
  },
];
